import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useWindowSize } from '@react-hook/window-size';
import { ChipHeatmap } from '@resistapp/client/components/plots/chip-heatmap';
import { SimpleLineChart } from '@resistapp/client/components/plots/simple-line-chart';
import { useContainerWidth } from '@resistapp/client/hooks/use-container-width';
import { useRef } from 'react';
import { useChipContext } from './use-chip-context';

export function ChipViewCharts() {
  const { heatmapData, selectedSamples, selectedGroups, ampCurves, derCurves, showRejected } = useChipContext();
  const graphColumnRef = useRef<HTMLDivElement | null>(null);
  const graphColumnWidth = useContainerWidth(graphColumnRef);
  const [, windowHeight] = useWindowSize();

  // Fallback width if measurement not yet available
  const effectiveGraphWidth = Math.max(100, (graphColumnWidth ?? 0) - 1);

  // Heatmap should be a square whose side length is the smaller of:
  //  1) 75% of the viewport height, and
  //  2) 75% of the available graph column width.
  const heatmapSide = Math.max(100, Math.min(windowHeight * 0.75, effectiveGraphWidth * 0.75));

  return (
    <Box flexGrow={1} minWidth={0} ref={graphColumnRef}>
      {/* Heatmap first */}
      <GraphContainer>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <ChipHeatmap
            data={heatmapData}
            width={heatmapSide}
            height={heatmapSide}
            selectedSamples={selectedSamples}
            selectedAssays={selectedGroups}
            showRejected={showRejected}
          />
        </Box>
      </GraphContainer>
      <Box height="32px" />
      <GraphContainer>
        <SimpleLineChart curves={ampCurves} width={effectiveGraphWidth} height={300} showRejected={showRejected} />
      </GraphContainer>
      <Box height="32px" />
      <GraphContainer>
        <SimpleLineChart curves={derCurves} width={effectiveGraphWidth} height={300} showRejected={showRejected} />
      </GraphContainer>
    </Box>
  );
}

const GraphContainer = styled(Box)`
  /* Container solely provides spacing; border & background are rendered by chart */
  padding: 0;
  overflow: visible;
`;
